<h2 mat-dialog-title class="izy-dialog-title">
  {{ isEdit ? 'Modifica attività' : 'Nuova attività' }}
</h2>

<form #eventForm="ngForm" (ngSubmit)="submit(eventForm)">
  <mat-dialog-content class="izy-dialog-body">
    <p class="izy-dialog-hint">
      Un promemoria personale che comparirà sulla bacheca nel giorno scelto.
    </p>

    <!-- .izy-fields va sul contenitore, non sul singolo campo: la regola
         globale (styles.scss) veste i mat-form-field discendenti con il
         contorno nero 2px e raggio 16px del resto dell'app. -->
    <div class="izy-fields">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Titolo</mat-label>
        <input
          matInput
          name="title"
          required
          maxlength="256"
          autocomplete="off"
          placeholder="Es. Inviare il preventivo a Rossi"
          [(ngModel)]="model.title"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Dettaglio (facoltativo)</mat-label>
        <input
          matInput
          name="sub_title"
          maxlength="256"
          autocomplete="off"
          placeholder="Una riga in più per ricordarti il contesto"
          [(ngModel)]="model.sub_title"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Note (facoltativo)</mat-label>
        <textarea
          matInput
          name="notes"
          rows="3"
          maxlength="512"
          placeholder="Tutto quello che ti serve ricordare su questo impegno"
          [(ngModel)]="model.notes"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Data</mat-label>
        <input
          matInput
          name="date"
          required
          [matDatepicker]="picker"
          [(ngModel)]="model.date"
        />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-checkbox
      name="is_important"
      color="primary"
      class="izy-dialog-checkbox"
      [(ngModel)]="model.is_important"
    >
      Segnala come importante
    </mat-checkbox>
    <p class="izy-dialog-hint izy-dialog-hint--tight">
      Le attività importanti vengono evidenziate e restano in cima alla giornata.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="izy-dialog-actions">
    <button mat-stroked-button type="button" class="izy-button-ghost custom-button-border" mat-dialog-close>
      Annulla
    </button>
    <button
      matButton="filled"
      type="submit"
      class="izy-button-primary custom-button-border"
      [disabled]="eventForm.invalid || saving"
    >
      {{ isEdit ? 'Salva' : 'Aggiungi' }}
    </button>
  </mat-dialog-actions>
</form>
